/**
 * The `<a>` both markdown renderers emit. Web links open in a new tab;
 * `jarvis://open` links (rewritten `file://`, see `lib/markdownUrls.ts`)
 * navigate in place — the browser hands them to Jarvis Helper and stays on
 * the page, where a new tab would be left behind blank. Site-absolute paths
 * (the ID links, `lib/idLinks.ts`) navigate inside the app.
 */
import type { MouseEventHandler, ReactNode } from "react";
import { Link } from "react-router-dom";

import { isLocalOpenUrl } from "../lib/markdownUrls";

export function LinkAnchor({
  href,
  onClick,
  children,
}: {
  href?: string;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
  children?: ReactNode;
}) {
  if (href && href.startsWith("/") && !href.startsWith("//")) {
    return (
      <Link to={href} onClick={onClick} className="link">
        {children}
      </Link>
    );
  }
  if (isLocalOpenUrl(href)) {
    return (
      <a href={href} onClick={onClick} title="Open locally via Jarvis Helper">
        {children}
      </a>
    );
  }
  return (
    <a href={href} target="_blank" rel="noreferrer" onClick={onClick}>
      {children}
    </a>
  );
}
